import DatePicker from "../../../../form/DatePicker";
import Drawer from "../../../../drawer/Drawer";
import Button from "../../../../form/Button";

const SaleDrawer = ({
  open,
  close,
  filters,
  setFilters = () => {},
  onRunReport = () => {},
}) => {
  const handleReset = () => {
    setFilters({});
  };

  const handleRunReport = async () => {
    try {
      onRunReport();
    } catch (error) {
      console.error("Error in handleRunReport:", error);
    }
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Drawer
      open={open}
      onClose={close}
      actualSize={"md"}
      size={"xl2"}
      title="Add Filters"
      subtitle=""
      drawerBodyClass="p-0 max-h-[calc(100%-40px)] overflow-y-auto"
    >
      <div className="p-6">
        {/* Header with Title and Reset */}
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-xl font-medium text-gray-900">Add Filters</h2>
          <Button
            buttonLabel={"Reset"}
            buttonFunction={handleReset}
            variant="secondary"
          />
        </div>

        <div className="space-y-8">
          {/* Order Date Range */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <label className="text-gray-900 font-medium text-base">
                Order Date Range
              </label>
            </div>

            <div className="space-y-3">
              <DatePicker
                label={""}
                labelClasses={"!text-sm !text-gray-500 !mb-2 !font-medium"}
                placeholder={"All Time"}
                inputClassName={
                  "!border-gray-300 !bg-white !h-12 !font-medium !text-gray-900 !rounded-md"
                }
                range
                onChange={(val) => {
                  setFilters((prev) => ({
                    ...prev,
                    startDate: val?.startDate?.toISOString(),
                    endDate: val?.endDate?.toISOString(),
                  }));
                }}
                value={{
                  startDate: filters?.startDate,
                  endDate: filters?.endDate,
                }}
              />
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 mt-12 pt-8">
          <Button
            buttonLabel={"Cancel"}
            buttonFunction={handleCancel}
            variant="secondary"
            buttonClasses="flex-1 px-6 py-3 border border-gray-300 rounded-md text-gray-700 font-medium hover:bg-gray-50 transition-colors text-base"
          />
          <Button
            buttonLabel={"Run report"}
            buttonFunction={handleRunReport}
            variant="primary"
            buttonClasses={`flex-1 px-6 py-3 rounded-md font-medium text-base transition-colors text-white hover:bg-blue-700 cursor-pointer`}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default SaleDrawer;
